import { Flex, StyleSystemProps, styled } from '@withjoy/joykit';

export const StyledFilterChip = styled(Flex)``;
const filterChipStyles = (isActive: boolean): StyleSystemProps => ({
  cursor: 'pointer',
  backgroundColor: isActive ? 'mono14' : 'white',
  color: isActive ? 'white' : 'mono14',
  borderRadius: 16,
  border: '2px solid',
  borderColor: 'mono14',
  paddingX: 4,
  height: 7,
  alignItems: 'center',
  justifyContent: 'center',
});

export const styles = {
  filterChip: filterChipStyles,
};
